import { EChartIndicator } from '@webtrader/core/chart/indicators';

import { EEventMessageType } from './index';

export interface IPostEventIndicatorMessage {
  type: typeof EEventMessageType.INDICATOR;
  data: EChartIndicator;
  needSort?: boolean;
}

export interface IReceiveEventIndicatorMessage {
  type: typeof EEventMessageType.INDICATOR;
  data: EChartIndicator;
}

export enum EInputType {
  DECIMAL = 'DECIMAL',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export interface IIndicatorConfigField {
  value: string;
  label: string;
  defaultValue: string;
  type: EInputType;
}

export interface IIndicatorFormMessageData {
  indicator: EChartIndicator;
  inputFields?: IIndicatorConfigField[];
  styleFields?: IIndicatorConfigField[];
}

export interface IReceiveEventOpenIndicatorFormMessage {
  type: typeof EEventMessageType.OPEN_INDICATOR_CONFIG;
  data: IIndicatorFormMessageData;
}

export interface IPostEventUpdateIndicatorFormMessage {
  type: typeof EEventMessageType.UPDATE_INDICATOR_CONFIG;
  data: IIndicatorFormMessageData;
}

export interface IPostEventTokenFormMessage {
  type: typeof EEventMessageType.TOKEN;
  data: string;
}

export interface IReceiveEventIndicatorLoadMessage {
  type: typeof EEventMessageType.INDICATOR_LOAD;
  data: boolean;
}
